import { CustomPageHeading } from "../../../components/CustomPageHeading/CustomPageHeading";
import { useUiTranslator } from "../../../hooks/useUiTranslator";

import { JSX, Suspense } from "react";

import { useGetByIdQuotes, useGetByIdQuotesKey } from "@4pace-cpq/core/api";
import { Skeleton } from "@mui/material";
import { useChildMatches, useParams } from "@tanstack/react-router";

type SubnavigationItems = Array<{
  id: string;
  disabled: boolean;
  to: string;
  label: string;
}>;

export function QuoteDetailsViewPageHeader({
  subNavigationItems,
}: {
  subNavigationItems: SubnavigationItems;
}): JSX.Element {
  const t = useUiTranslator();
  const { quoteId: quoteIdParam } = useParams({
    strict: false,
  });

  const { data: quote } = useGetByIdQuotes(
    { path: { id: quoteIdParam } },
    [useGetByIdQuotesKey],
    {
      enabled: !!quoteIdParam,
    },
  );

  const childMatches = useChildMatches();
  const routeId = childMatches[0].routeId;

  const activeNavigationItem = subNavigationItems.filter(
    (item) => item.to === routeId,
  );

  return (
    <Suspense
      fallback={
        <Skeleton
          variant="rectangular"
          sx={{
            marginTop: "1rem",
            width: "100%",
            height: "46.433px",
          }}
        />
      }
    >
      <CustomPageHeading
        text={t(
          `CustomApp:header.${activeNavigationItem[0].id}.title`,
          activeNavigationItem[0].label,
        )}
        subtitle={quote?.name}
      />
    </Suspense>
  );
}

export default QuoteDetailsViewPageHeader;
